import React, { useEffect, useState } from 'react'
import Logo from '../assets/logo.png'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../context/AuthContext.js';



const Register = () => {
  const navigate = useNavigate();

  const {signup, isAuthenticated, errorMessage, authIsLoading} = useAuth();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    role: '',
  })


  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData({ ...formData, [name]: value});
    console.log('this is formdata', formData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    signup(formData)
  }

  useEffect(function(){
    if (isAuthenticated) {
      toast.success('Successfully registered!', {position: "top-right", autoClose: 2000})
      setTimeout(() => {
        navigate('/dashboard')
      }, 2000)
    }
  }, [isAuthenticated, navigate])

  useEffect(function(){
    if(errorMessage){
      toast.error(errorMessage, {position: "top-right", autoClose: 2000})
    }
  }, [errorMessage])




  return (
    <div className="login-reg-container">
    <ToastContainer />

    <div className="content-wrapper">
                <Link className="logo-container" to='/'>
       
                <img src={Logo} alt="Homify Logo" className="logo" />
          
          </Link>
      <h2>Simplify house hunting today.</h2>
      <p>PropTera is your go-to real estate platform, connecting property seekers in Lagos, Nigeria, with property owners and agents.</p>
    </div>
    <div className="form-wrapper">
      <div className="form-content">
        <h1>Create Your PropTera Account</h1>
        <form id="registerForm" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="name">Full Name</label>
            <input onChange={handleChange} type="text" id="name" name="name" required />
          </div>
          <div className="input-group">
            <label htmlFor="email">Email Address</label>
            <input onChange={handleChange} type="email" id="email" name="email" required />
          </div>
          <div className="input-group">
            <label htmlFor="phone">Phone Number</label>
            <input onChange={handleChange} type="tel" id="phone" name="phone" required />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input onChange={handleChange} type="password" id="password" name="password" required />
          </div>
          <div className="input-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input onChange={handleChange} type="password" id="confirmPassword" name="confirmPassword" required />
          </div>
          <div className="input-group">
            <label htmlFor="role">Role</label>
            <select onChange={handleChange} required defaultValue="" id="role" name="role">
              <option value="" disabled>Select your role</option>
              <option value="buyer">Buyer</option>
              <option value="seller">Seller</option>
              <option value="agent">Agent</option>
            </select>
          </div>


          <button type="submit" id="register-btn">
            {
              authIsLoading ? 'Registering...' : 'Register'
            }
          </button>
          {/* <div className="social-login">
            <button type="button" className="social-btn google-btn">Register with Google</button>
            <button type="button" className="social-btn facebook-btn">Register with Facebook</button>
          </div> */}
          <Link to='/login'>
            <p className="message">Already have an account? <span style={{color:'#4CAF50'}}>Sign In</span> </p>
          </Link>
        </form>
      </div>
    </div>
  </div>
  )
}

export default Register